import React from "react";

import ListItem from "./ListItem";

export default function List() {
  return (
    <div className="bg-[#E9E3D0] py-[50px] px-6 text-dark-blue flex flex-col gap-12">
      <ListItem
        key={1}
        number={1}
        title="En personlig rådgivare"
        desc="En erfaren expert vägleder dig under hela vägen och finns tillgänglig för personligt möte. Vi vet att de flesta aldrig har arrangerat en begravning förut. Därför hjälper vi dig med allt för en trygg och vacker begravning
– precis som du vill ha det."
        image={
          <div className="bg-flower1 absolute h-[130%] w-[130%] bg-contain bg-no-repeat bottom-0 bg-[center_right_3px]"></div>
        }
      />
      <ListItem
        key={2}
        number={2}
        title="Skräddarsydda farväl"
        desc="Vi erbjuder dig allt från enkel kremering med en passande urna – till vackra begravningsceremonier. Fenix hjälper dig även med allt du behöver gällande bodelning och andra juridiska frågor. Ta del av våra paket nedan."
        image={
          <div className="bg-flower2 absolute h-[114%] w-[130%] bg-contain bg-no-repeat bottom-[-8px] bg-[center_left_10px]"></div>
        }
      />
      <ListItem
        key={3}
        number={3}
        title="Sörj i lugn och ro"
        desc="Få utrymme att ta hand om nära, kära och dig själv. Vi hjälper dig med allt det andra – innan, under såväl som efter begravningen."
        image={
          <div className="bg-flower3 absolute h-[130%] w-[140%] bg-contain bg-no-repeat bottom-[-16px] bg-[center_right]"></div>
        }
      />
    </div>
  );
}
